var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationSablier = function SvgIllustrationSablier(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--color-primary)",
    viewBox: "0 0 181 180",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123.2,
    cy: 126.5,
    r: 27.8,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 123.2 126.5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 53.3,
    r: 27.8,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 57.5 53.3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m134.5 61.5 2.226-18.668 18.668 2.226-2.226 18.668zM25.5 138.2l4.133-18.34 18.34 4.133-4.133 18.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M92 47.8a43.8 43.8 0 0 0-44.2 43.4c0 23.9 19.8 43.3 44.2 43.3a43.8 43.8 0 0 0 44.2-43.3c0-24-19.8-43.4-44.2-43.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M92 88.7a7 7 0 0 0 5.4-2.3 7.9 7.9 0 0 0 2.1-5.6v-5.6h-15v5.6c0 2.2.8 4.1 2.2 5.6a7 7 0 0 0 5.3 2.3m-14.4 23c-.6 0-1.1-.2-1.6-.7-.4-.4-.6-1-.6-1.6s.2-1.2.6-1.6c.5-.4 1-.7 1.6-.7H80v-5.6c0-2.2.5-4.2 1.6-6 1-2 2.4-3.4 4.3-4.3-1.9-1-3.3-2.4-4.3-4.3S80 83 80 80.9v-5.7h-2.4c-.6 0-1.1-.2-1.6-.6-.4-.5-.6-1-.6-1.7 0-.6.2-1.1.6-1.6.5-.4 1-.7 1.6-.7h28.8c.6 0 1.2.3 1.6.7.5.5.7 1 .7 1.7 0 .6-.2 1.1-.7 1.6-.4.4-1 .6-1.6.6h-2.3v5.6c0 2.2-.5 4.2-1.6 6-1 2-2.5 3.4-4.4 4.4 2 1 3.4 2.4 4.4 4.2 1 1.9 1.6 4 1.6 6v5.7h2.3c.6 0 1.2.3 1.6.7.5.4.7 1 .7 1.6 0 .7-.2 1.2-.7 1.6-.4.5-1 .7-1.6.7z"
  })));
};
export default SvgIllustrationSablier;